"use client";
import React, { useEffect, useState } from "react";
import Styles from "./style.module.css";
import { FiUser } from "react-icons/fi";
import { FiShoppingBag } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import {
    getOrderDetails,
    UpdaterOrderApi,
    UpdateOrderStatus,
} from "Services/Requests";
import { toast } from "react-toastify";
import { OrdersTypes } from "./Types";
import LoaderComp from "Components/Modal_load/load";
import moment from "moment";
import { useParams } from "react-router";
import AltImage from "Assets/altimg.png";
import { IoLocationSharp } from "react-icons/io5";

import { confirmAction } from "Util/Alerts";
import { message } from "antd";
function Page() {
    const { id } = useParams();
    const [Loader, setLoader] = useState(true);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [ShowTrackModal, setShowTrackModal] = useState(false);
    const [modalLoad, setModalLoad] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [details, setDetails] = useState<OrdersTypes>();
    const getData = async () => {
        if (id) {
            try {
                const ApiData = await getOrderDetails(Number(id));
                if (ApiData?.data?.status === 1) {
                    setTimeout(() => {
                        setLoader(false);
                        setDetails(ApiData?.data?.data);
                    }, 500);
                }
            } catch (err) {
                console.log(err);
                toast.warning("Something went wrong try again", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                // setLoader(false);
            }
        }
    };

    useEffect(() => {
        getData();
    }, []);
    const UpdateStatus = async (value: string) => {
        let body = { order_id: id, order_status: value };
        try {
            setLoader(true);
            const ApiData = await UpdateOrderStatus(body);
            if (ApiData?.data?.status === 1) {
                getData();
                message.success("Order Status Updated");
            }
        } catch (err) {
            console.log(err);
            setLoader(false);
            toast.warning("Something went wrong try again", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            // setLoader(false);
        }
    };

    const changeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        let { value } = event.target;

        let status =
            value == "1"
                ? "Pending"
                : value == "2"
                ? "Transit"
                : value == "3"
                ? "Delivered"
                : "Cancelled";
        confirmAction(
            "Warning",
            `Are you sure you want to update Status to ${status}?`,
            () => UpdateStatus(value),
            "Update Status"
        );
    };
    return (
        <div className={Styles["Container"]}>
            {Loader && <LoaderComp />}

            <header>
                <div>
                    <h3>Order ID: {details?.order_id} </h3>
                    <select
                        value={details?.order_status}
                        onChange={changeHandler}>
                        {" "}
                        <option value="1">Pending</option>
                        <option value="2">Transit</option>
                        <option value="3">Delivered</option>
                        {/* <option value="3">Cancelled</option> */}
                    </select>
                    {/*  {(details?.order_status == 1 ||
                        details?.order_status == 2) && (
                        <button
                            className={Styles["cancelOrder"]}
                            onClick={() => setShowModal(true)}>
                            Cancel Order
                        </button>
                    )} */}
                </div>
                <p>
                    {" "}
                    {moment(details?.created_at).format(
                        "MMMM Do YYYY [at] hh:mm A"
                    )}
                </p>
            </header>
            <div className={Styles["order-details"]}>
                <div className={Styles["Order_data"]}>
                    <h3>Order Items</h3>
                    {details?.products?.map((item, index) => (
                        <div className={Styles["Item"]} key={index}>
                            <div className={Styles["Item_left"]}>
                                {item.product_image.length > 0 ? (
                                    <img
                                        src={item?.product_image[0]}
                                        alt=""
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src = AltImage;
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={AltImage}
                                        alt=""
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src = AltImage;
                                        }}
                                    />
                                )}
                                {/*  <img
                                    src={item?.product_image[0]}
                                    alt=""
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = AltImage;
                                    }}
                                /> */}
                                <div>
                                    <h4>{item?.category_name}</h4>
                                    <p>{item?.product_name}</p>
                                    <p>
                                        {" "}
                                        Giveaway Product:
                                        <b> {item?.giveaway_product_name}</b>
                                    </p>
                                    <p>
                                        Campaign Code{" "}
                                        <b>P{item?.campaign_code}</b>
                                    </p>
                                </div>
                            </div>
                            <div className={Styles["prices"]}>
                                <p>
                                    {item?.order_item_qty} x ₹{" "}
                                    {item?.order_item_price /
                                        item?.order_item_qty}
                                </p>
                                <p> ₹ {item?.order_item_price}</p>
                            </div>
                        </div>
                    ))}

                    <div className={Styles["Summary"]}>
                        {/*    <h3>
                            Order Summary{" "}
                            {details?.invoice && details?.invoice != "NA" && (
                                <button
                                    className={Styles["download"]}
                                    onClick={() =>
                                        window.open(details?.invoice, "_blank")
                                    }>
                                    <MdFileDownload size={"15"} /> Download
                                    Invoice
                                </button>
                            )}
                        </h3> */}
                        <div className={Styles["Price"]}>
                            <p>Order Type</p>
                            {details?.order_type == 1 ? (
                                <p className={Styles["cod"]}>COD</p>
                            ) : (
                                <p className={Styles["online"]}>Online</p>
                            )}
                        </div>
                        <div className={Styles["Price"]}>
                            <p>Order Amount</p>
                            <p> ₹ {details?.order_amount}</p>
                        </div>
                        <div className={Styles["Price"]}>
                            <p>Convience Fee</p>
                            <p> ₹ {details?.convience_fee}</p>
                        </div>
                        <div className={Styles["Price"]}>
                            <p>Discount</p>
                            <p> ₹ {details?.coupon_discount}</p>
                        </div>
                        <div className={Styles["Price"]}>
                            <p>Total</p>
                            <b> ₹ {details?.grand_total}</b>
                        </div>
                    </div>
                </div>

                <div className={Styles["customer_info"]}>
                    <div className={Styles["info"]}>
                        <h3>Customer</h3>
                        <p>
                            <FiUser /> {details?.first_name}{" "}
                            {details?.last_name}
                        </p>
                        <p>
                            <IoLocationSharp />{" "}
                            {details?.address.building_address} <br />
                            {details?.address.street_and_city}
                            <br />
                            {details?.address.state}
                            <br />
                            {details?.address.pincode}
                        </p>
                        <p>
                            <FiShoppingBag /> {details?.products?.length} Items
                        </p>
                    </div>
                    <div className={Styles["info"]}>
                        <h3>Contact Information</h3>
                        {/*  <p>
                            <MdOutlineEmail /> {details?.address.state}
                        </p> */}
                        <p>
                            <IoCallOutline /> {details?.mobile_number}
                        </p>
                    </div>

                    {/* <div
                        className={Styles["info"]}
                        style={{ display: "flex", gap: "0.5rem" }}>
                        <h3>
                            Tracking URL{" "}
                            <button onClick={() => setShowTrackModal(true)}>
                                <BsPencilSquare />
                            </button>
                        </h3>{" "}
                        :{" "}
                        <p>
                            {details?.tracking_url ? (
                                <a
                                    href={details?.tracking_url}
                                    target="_blank"
                                    referrerPolicy="no-referrer">
                                    Track
                                </a>
                            ) : (
                                "NA"
                            )}
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default Page;
